import { render, staticRenderFns } from "./PopoverCleanUpSuggestion.vue?vue&type=template&id=d5bb9a76&scoped=true&"
import script from "./PopoverCleanUpSuggestion.vue?vue&type=script&lang=js&"
export * from "./PopoverCleanUpSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./PopoverCleanUpSuggestion.vue?vue&type=style&index=0&id=d5bb9a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bb9a76",
  null
  
)

export default component.exports